import React, { useState } from "react";
import { triggerApplyModal } from "../App";
import "./Help.css";

const faqs = [
  {
    category: "Applying & Qualifying",
    question: "What do I need to qualify for a loan?",
    answer:
      "Typically, you'll need an active checking account, a steady source of income, and to meet age/residency requirements. Our application will walk you through the simple steps.",
  },
  {
    category: "Applying & Qualifying",
    question: "How fast can I get the money?",
    answer:
      "Once approved, funds are usually deposited into your account as soon as the next business day. Timing depends on your bank.",
  },
  {
    category: "Fees & Repayment",
    question: "What are the fees and costs?",
    answer:
      "All finance charges and fees are disclosed clearly in your loan agreement before you sign. We're committed to transparent pricing with no hidden fees.",
  },
  {
    category: "Fees & Repayment",
    question: "When is repayment due?",
    answer:
      "Your loan is typically due on your next payday or scheduled deposit date. The exact due date will be clearly stated in your agreement.",
  },
  {
    category: "Security & Trust",
    question: "Is my personal information secure?",
    answer:
      "Yes. We use industry-standard encryption and security protocols to protect your data throughout the entire process.",
  },
  {
    category: "Security & Trust",
    question: "What if I can't repay on time?",
    answer:
      "Contact our support team immediately. We may be able to discuss options to help you avoid additional fees, though extensions are not guaranteed and may involve extra costs.",
  },
  {
    category: "General",
    question: "How do I contact customer support?",
    answer:
      "Our support team is available via phone and email during extended business hours to assist with your questions.",
  },
  {
    category: "General",
    question: "Can I apply if I have bad credit?",
    answer:
      "We consider various factors beyond credit score, including income. We encourage you to complete our simple application to see if you qualify.",
  },
];

const popularArticles = [
  "Understanding loan costs and APR",
  "What to do if my payment is late",
  "How to update my bank account information",
  "State-specific lending regulations",
];

const Help = () => {
  const [search, setSearch] = useState("");

  const filteredFaqs = faqs.filter(
    (f) =>
      f.question.toLowerCase().includes(search.toLowerCase()) ||
      f.answer.toLowerCase().includes(search.toLowerCase()) ||
      f.category.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="help-wrapper">
      <h2 className="help-title">Help & Support</h2>
      <p className="help-subtitle">Get answers about your short-term loan</p>

      <div className="search-box">
        <input
          type="text"
          placeholder="Search for help (e.g., 'repayment', 'qualify', 'fees')..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="popular-section">
        <h3>Common Topics</h3>
        <ul>
          {popularArticles.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </div>

      <div className="faq-grid">
        {filteredFaqs.length > 0 ? (
          filteredFaqs.map((faq, index) => (
            <div key={index} className="faq-card">
              <span className="category">{faq.category}</span>
              <h3>{faq.question}</h3>
              <p>{faq.answer}</p>
            </div>
          ))
        ) : (
          <p className="no-results">No results found. Try another search term.</p>
        )}
      </div>

      <div className="help-cta">
        <h3>Need immediate assistance?</h3>
        <p>Our team is here to help with your loan questions.</p>
        <button 
          className="contact-btn"
          onClick={() => triggerApplyModal('Customer Support Inquiry')}
        >
          Contact Support Now
        </button>
      </div>
    </div>
  );
};

export default Help;